import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { MenuService } from 'src/app/services/menu.service';
import { Router } from '@angular/router';
import { MedicalFeePaymentManualSearchItem } from '../../../model/medical-fee/medical-fee-payment-manual-search-item';
import { MedicalFeeService } from '../../../services/medical-fee/medical-fee.service';
import { ReportViewerDialogComponent } from '../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalFeePaymentManualService } from '../../../services/medical-fee/medical-fee-payment-manual.service';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';

@Component({
  selector: 'app-medical-fee-payment-manual-search',
  templateUrl: './medical-fee-payment-manual-search.component.html',
  styleUrls: ['./medical-fee-payment-manual-search.component.css']
})
export class MedicalFeePaymentManualSearchComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'Physician', 'Amount',
  'PayDate', 'MedicalFeePeriodName', 'Star'];
  dataSource = new MatTableDataSource([]);
  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];

  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor( private menuService: MenuService,
               private medicalFeeService: MedicalFeeService,
               private notificationToastService: NotificationToastService,
               private dialog: MatDialog,
               private mfpManualService: MedicalFeePaymentManualService,
               private confirmDialogService: ConfirmDialogService,
               private route: Router ) {

    this.menuService.setMenuTitle('Honorarios', 'Generar liquidación manual');
  }

  ngOnInit() {
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch( response: IFilterResponse<MedicalFeePaymentManualSearchItem> ) {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
    this.loading = false;
  }

  onStartSearch() {
    this.loading = true;
  }

  cancel( item: MedicalFeePaymentManualSearchItem ) {

    this.confirmDialogService.confirm( 'Cancelar honorarios',
      'Está seguro que desea cancelar los honorarios?', 'Sí', 'No' )
      .subscribe( value => {

        if ( value ) {

          this.mfpManualService.cancelMedicalFeeBill( item.Id );
          this.searchFilter.search();
        }

      });
  }

  async viewReport( item: MedicalFeePaymentManualSearchItem ) {

    try {
      item.Loading = true;
      const reportViewer = await this.medicalFeeService
            .getMedicalFeeReport(item.Id, true);
      this.dialog.open(ReportViewerDialogComponent, {
        width: '90%',
        height: '600px',
        data: reportViewer
      });
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Honorarios');
    } finally {
      item.Loading = false;
    }
  }

  create() {
    this.route.navigate([ 'medical-fee-payment-wizard' ]);
  }

}
